import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, CheckCircle2 } from 'lucide-react';
import { usePage } from '../contexts/PageContext';
import SEO from '../components/SEO';

export default function ThankYouPage() {
  const { t, seo } = usePage('thank_you');
  return (
    <>
      <SEO title={seo.title} description={seo.description} keywords={seo.keywords} />
      <section className="py-32 min-h-[80vh] flex items-center">
        <div className="container-x text-center max-w-3xl mx-auto">
          <div className="mx-auto w-20 h-20 rounded-full border border-[#C6C4CF] text-[#C6C4CF] flex items-center justify-center"><CheckCircle2 size={40} /></div>
          <h1 className="heading-display mt-10 text-[40px] sm:text-[64px] lg:text-[88px]">{t('title', 'Thank you for reaching out!')}</h1>
          <p className="mt-8 text-[16px] text-[#C6C4CF] max-w-xl mx-auto">{t('description', '')}</p>
          <div className="mt-14 border-t border-[#3A332A]">
            <p className="mt-8 text-xs uppercase tracking-[0.28em] text-[#C6C4CF]">{t('next_title', 'While you wait')}</p>
            <ul className="mt-6 space-y-2 max-w-xl mx-auto">
              <NextItem to="/security">{t('next_1', 'Read our security overview')}</NextItem>
              <NextItem to="/pricing">{t('next_2', 'Explore our pricing model')}</NextItem>
              <NextItem href="https://app.clicksyhub.com">{t('next_3', 'Visit our app at app.clicksyhub.com')}</NextItem>
            </ul>
          </div>
          <Link to="/" className="btn-outline mt-12 inline-flex"><span>{t('cta_back', 'Back to home')}</span><span className="arrow"><ArrowUpRight size={14} /></span></Link>
        </div>
      </section>
    </>
  );
}

function NextItem({ to, href, children }) {
  const Cmp = href ? 'a' : Link;
  const props = href ? { href, target: '_blank', rel: 'noreferrer' } : { to };
  return (
    <li>
      <Cmp {...props} className="group flex items-center justify-between p-4 border-b border-[#3A332A] hover:border-[#F5F137] transition-colors">
        <span className="text-left text-[#FAF6EF] group-hover:text-[#F5F137] transition-colors">{children}</span>
        <ArrowUpRight size={16} className="text-[#C6C4CF] group-hover:text-[#F5F137] group-hover:rotate-45 transition-all" />
      </Cmp>
    </li>
  );
}
